export enum ESettingsEmailsField {
  ID_MAILER = 'id_mailer',
  LOCALE = 'locale',
  SUBJECT = 'subject',
  BODY = 'body',
  ENABLED = 'enabled',
  PREFIX_MAILER = 'mailer',
}
